export const QueryString = {
  Limit: 'l',
  SortField: 'sf',
  SortOrder: 'so',
  Page: 'p',
  Search: 'search',
};

export const SortOrder = {
  desc: -1,
  asc: 1,
};
